import React, { useEffect, useState } from "react";
import { Link, useLocation, navigate } from "components/Router";
import { deleteCookie, isBrowser } from "components/Browser";
import PageLoadComponent from "components/PageLoad";
import { useSessionContext } from "components/Session";
import { anyCommonElements } from "components/SetUtil";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import Spinner from "react-bootstrap/Spinner";
import log from "loglevel";
import popUpImage from "../img/women-using-app.png";
import { IS_ALPHA_STAGE, KIBANA_ENDPOINT } from "../api-config.mjs";
// import logo from '../img/earnings-call-logo-small.png';
import logo from "../img/earnings-call-brand.svg";
import logoMobile from "../img/logo-mobile.png";
import userAvatar from "../img/user-preview.png";
import codixel from "../img/codixel.svg";
import { useNProgress } from "@tanem/react-nprogress";
import loadable from "@loadable/component";
import BreadCrumbTrail from "./BreadCrumbTrail";
import { destroySession, getNotifications } from "api.mjs";
import {
  APPLE_APP_STORE_URL,
  GOOGLE_PLAY_STORE_URL,
} from "components/AppStoreUtil";
import Badge from "react-bootstrap/Badge";
import StoreBadge from "react-store-badge";

import {
  CHAT_AI,
  STRIPE_CUSTOMER_ADMIN,
  isFeatureEnabled,
} from "components/Features";
import { Modal } from "react-bootstrap";

const SearchBar = loadable(() => import("../containers/SearchBar"));

const BarContainer = ({ animationDuration, children, isFinished }) => (
  <div
    style={{
      opacity: isFinished ? 0 : 1,
      pointerEvents: "none",
      transition: `opacity ${animationDuration}ms linear`,
    }}
  >
    {children}
  </div>
);

const Bar = ({ animationDuration, progress }) => (
  <div
    style={{
      background: "#29d",
      height: 2,
      left: 0,
      marginLeft: `${(-1 + progress) * 100}%`,
      position: "fixed",
      top: 0,
      transition: `margin-left ${animationDuration}ms linear`,
      width: "100%",
      zIndex: 1031,
    }}
  >
    <div
      style={{
        boxShadow: "0 0 10px #29d, 0 0 5px #29d",
        display: "block",
        height: "100%",
        opacity: 1,
        position: "absolute",
        right: 0,
        transform: "rotate(3deg) translate(0px, -4px)",
        width: 100,
      }}
    />
  </div>
);

// If this doesn't do what we want, we could try using this library:
// https://klendi.github.io/react-top-loading-bar/
const Progress = ({ isAnimating }) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating,
    animationDuration: 10,
    incrementDuration: 10,
    minimum: 0.08,
  });

  return (
    <>
      <BarContainer
        animationDuration={animationDuration}
        isFinished={isFinished}
      >
        <Bar animationDuration={animationDuration} progress={progress} />
      </BarContainer>
    </>
  );
};

const isActive = (currentPath, pathToCheck) => {
  log.debug("isActive", currentPath, pathToCheck);
  if (currentPath === pathToCheck) {
    return "active";
  }
  return "";
};

const AdminDropDownItem = ({ title, path, roles, allowedRoles, href }) => {
  if (!anyCommonElements(roles, allowedRoles)) {
    return <></>;
  }
  if (href) {
    return (
      <>
        <NavDropdown.Item href={href}>{title}</NavDropdown.Item>
        <NavDropdown.Divider />
      </>
    );
  }
  return (
    <>
      <NavDropdown.Item as={Link} to={path}>
        {title}
        <span className="visually-hidden">unread messages</span>
      </NavDropdown.Item>
      <NavDropdown.Divider />
    </>
  );
};

const DownloadModal = ({ show, handleClose }) => {
  return (
    <>
      <Modal
        className="download-app-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Body>
          <div className="img-container">
            <img src={popUpImage} alt="women" />
          </div>
          <div className="text-content">
            Download EarningsCall Apps in your mobile
          </div>
          <StoreBadge
            name="EarningsCall"
            googlePlayUrl={GOOGLE_PLAY_STORE_URL}
            appStoreUrl={APPLE_APP_STORE_URL}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const adminPageLinks = [
  { title: "News", path: "/news", allowedRoles: ["admin"] },
  { title: "Earnings", path: "/earnings", allowedRoles: ["admin"] },
  { title: "Company Info", path: "/company", allowedRoles: ["admin"] },
  { title: "Symbols", path: "/symbols", allowedRoles: ["admin"] },
  { title: "Audit History", path: "/audit", allowedRoles: ["admin"] },
  { title: "App Builds", path: "/builds", allowedRoles: ["admin", "blogger"] },
  // NOTE: This is not a Gatsby Link because we are navigating to Kibana, which is a completely separate app.
  { title: "Kibana", allowedRoles: ["admin"], href: KIBANA_ENDPOINT },
  {
    title: "Manage Blog",
    path: "/admin/blog/manage",
    allowedRoles: ["blogger"],
  },
  { title: "File Upload", path: "/file-upload", allowedRoles: ["developer"] },
];

const MainNavbar = (props) => {
  const { isAdminPage, analyticsOptions = {} } = props;
  const navbarClass = isAdminPage ? "top-navbar admin-page" : "top-navbar";
  const { sessionContext, setSessionContext } = useSessionContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchActive, setSearchActive] = useState(false);
  const [isLoadingNotificationsCount, setIsLoadingNotificationsCount] =
    useState(false);
  const [newNotifications, setNewNotifications] = useState();
  const [show, setShow] = useState(false);

  const { isLoggedIn, isAdminUser, session } = sessionContext;
  const roles = session?.user?.roles || [];
  const sessionTokenExpiration = session ? session.expires : 0;
  const nowInSeconds = Date.now() / 1000;
  const minutesRemaining = Math.floor(
    Math.max(sessionTokenExpiration - nowInSeconds, 0) / 60
  );
  const hoursRemaining = Math.floor(
    Math.max(sessionTokenExpiration - nowInSeconds, 0) / 60 / 60
  );
  const user = session?.user || {};
  const google = user?.google || {};
  log.info("MainNavbar::session", session);
  const picture = google?.picture;
  const imageUrl = picture;
  const { email, given_name: givenName, name } = user || {};
  const userDisplayName = givenName || name || email;
  const { pathname, search, hash } = useLocation();
  log.debug("MainNavbar::pathname", pathname, hash);
  const newLocation = `${pathname}${search}${hash}`;
  log.debug("MainNavbar::newLocation", newLocation);
  log.debug("MainNavbar: email:", email);
  log.debug("MainNavbar: givenName:", givenName);
  log.debug(
    "MainNavbar: name:",
    name,
    "isAdminUser:",
    isAdminUser,
    "roles:",
    roles,
    "roles truthy:",
    !!roles
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const enableSubscriptionPage = true; // IS_ALPHA_STAGE || isFeatureEnabled(SUBSCRIPTION_PAGE);
  const enableApiKeyPage = true; // IS_ALPHA_STAGE || isFeatureEnabled(API_KEY_PAGE);
  const enableStripeCustomerAdmin =
    IS_ALPHA_STAGE || isFeatureEnabled(STRIPE_CUSTOMER_ADMIN);

  const enableChatAI = isFeatureEnabled(CHAT_AI);

  // log.debug(`UserInfo: ${JSON.stringify(sessionContext.userInfo)}`);

  useEffect(() => {
    // For now, disable the loading bar, due to bad lighthouse stats from this
    // setIsLoading(true);
    // setTimeout(() => setIsLoading(false), 500);
    // setTimeout(() => setIsLoading(false), 200);
  }, [pathname, hash, sessionContext, analyticsOptions]);

  useEffect(() => {
    // For now, disable the loading bar, due to bad lighthouse stats from this
    // setIsLoading(true);
    // setTimeout(() => setIsLoading(false), 500);
    // setTimeout(() => setIsLoading(false), 200);
    if (!isAdminUser) {
      return;
    }
    // In case you need to force Admin users to sign out, do this:
    // log.debug(`Is Admin User, logging out in 10 seconds!`);
    // setTimeout(() => {
    //   log.debug(`Logging out!`);
    //   // flushEvents();
    //   setSessionContext({});
    //   if (isAdminPage) {
    //     log.debug("Current path is an admin page, navigating back to home.");
    //     navigate("/");
    //   }
    // }, 3_000);

    setIsLoadingNotificationsCount(true);
    getNotifications({
      queryParams: {
        perform_aggregation: true,
      },
      context: {
        sessionContext: sessionContext,
      },
    })
      .then(({ new_notifications }) => {
        setNewNotifications(new_notifications);
        setIsLoadingNotificationsCount(false);
      })
      .catch((error) => {
        log.error("Error getting notifications:", error);
      });
  }, [pathname, isLoggedIn, isAdminUser, sessionContext, newLocation]);

  const onLogout = () => {
    log.debug("Logout.");
    setSessionContext({});
    deleteCookie("sid");
    destroySession({ context: { sessionContext } });
    navigate("/");
  };

  // TODO: Move into useEffect()
  if (
    isBrowser() &&
    isLoggedIn &&
    session &&
    nowInSeconds > sessionTokenExpiration
  ) {
    log.debug("Expired, logging user out of session.");
    setSessionContext({});
    if (isAdminPage) {
      log.debug("Current path is an admin page, navigating back to home.");
      navigate("/");
    }
  }
  return (
    <>
      <Progress isAnimating={isLoading} />
      <PageLoadComponent {...props} />
      <Navbar
        expand="md"
        className={`main-navbar ${navbarClass} ${
          isSearchActive ? "active-search" : ""
        }`}
        sticky="top"
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={logo}
              alt="EarningsCall Logo"
              className="d-none d-lg-block"
              style={{ width: "200px" }}
            />
            <img
              src={logoMobile}
              className="d-sm-block d-lg-none d-block"
              alt="EarningsCall Logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse className="" id="basic-navbar-nav">
            {/* close mobile side navbar */}

            <div className="mobile-nav-close">
              <div className="img-container">
                <img
                  src={logo}
                  className="d-md-none d-none"
                  alt="EarningsCall Logo"
                  style={{ width: "100px" }}
                />
              </div>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                className="without-focus border-0"
              >
                <div className="nav-close">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M12 1.503L10.497 0L6 4.497L1.503 0L0 1.503L4.497 6L0 10.497L1.503 12L6 7.503L10.497 12L12 10.497L7.503 6L12 1.503Z"
                      fill="#292929"
                    />
                  </svg>
                </div>
              </Navbar.Toggle>
            </div>

            {(isAdminUser || roles.length > 0) && (
              <>
                <NavDropdown title="ADMIN" id="basic-nav-dropdown">
                  <AdminDropDownItem
                    key={"notifications-nav-link"}
                    roles={roles}
                    title={
                      <>
                        {newNotifications > 0 && "⚠️ "}Notifications{" "}
                        <Badge bg="info">
                          {isLoadingNotificationsCount ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                role="status"
                                aria-hidden="true"
                                size="sm"
                              />
                            </>
                          ) : (
                            <>{newNotifications} new</>
                          )}
                        </Badge>{" "}
                        {newNotifications > 0 && "⚠️ "}
                      </>
                    }
                    path="/notifications"
                    allowedRoles={["admin"]}
                  />
                  {adminPageLinks.map((pageLink, index) => (
                    <AdminDropDownItem
                      key={index}
                      roles={roles}
                      {...pageLink}
                    />
                  ))}
                  <NavDropdown.Item as={Link} to="/newcalendar">
                    Calendar Overview
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            )}
            <ul className="navbar-nav align-items-md-center ms-md-auto ms-0 left-nav">
              {/* {isAdminUser && (
                <>
                  <li className="nav-item">
                    <Nav.Link as={Link} to="/test">
                      Test
                    </Nav.Link>
                  </li>
                </>
              )} */}

              <li className="nav-item d-none">
                <Nav.Link
                  as={Link}
                  to="/search"
                  className={isActive(pathname, "/search")}
                >
                  Search
                </Nav.Link>
              </li>
              <li className="nav-item d-none d-md-block">
                <Nav.Link
                  as={Link}
                  to="/calendar"
                  className={isActive(pathname, "/calendar")}
                >
                  Calendar
                </Nav.Link>
              </li>
              <li className={`nav-item ${enableChatAI || "d-none"}`}>
                <Nav.Link
                  as={Link}
                  to="/chat"
                  className={isActive(pathname, "/chat")}
                >
                  ChatAI
                </Nav.Link>
              </li>
              <li className="nav-item">
                <Dropdown className="pricing-dropdown">
                  <Dropdown.Toggle>
                    Pricing
                    <span className="toggle-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.219668 0.219668C0.512558 -0.0732225 0.987438 -0.0732225 1.28033 0.219668L5.75 4.6893L10.2197 0.219668C10.5126 -0.0732225 10.9874 -0.0732225 11.2803 0.219668C11.5732 0.512558 11.5732 0.987437 11.2803 1.2803L6.2803 6.2803C6.1397 6.421 5.9489 6.5 5.75 6.5C5.5511 6.5 5.3603 6.421 5.2197 6.2803L0.219668 1.2803C-0.0732225 0.987437 -0.0732225 0.512558 0.219668 0.219668Z"
                        />
                      </svg>
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <div className="icon-polygon"></div>

                    <div
                      className={`item-container ${enableChatAI || "d-none"}`}
                    >
                      <Link to="/chat-ai-pricing">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="23"
                            viewBox="0 0 24 23"
                            fill="none"
                          >
                            <path
                              d="M21.6 0H2.4C1.0768 0 0 1.0768 0 2.4V15.2C0 16.5232 1.0768 17.6 2.4 17.6H4.8V21.6C4.8 21.908 4.9768 22.1872 5.2528 22.3208C5.364 22.3736 5.4824 22.4 5.6 22.4C5.7784 22.4 5.9552 22.3408 6.1 22.2248L11.8808 17.6H21.6C22.9232 17.6 24 16.5232 24 15.2V2.4C24 1.0768 22.9232 0 21.6 0ZM12 11.2H5.6C5.1576 11.2 4.8 10.8416 4.8 10.4C4.8 9.9584 5.1576 9.6 5.6 9.6H12C12.4424 9.6 12.8 9.9584 12.8 10.4C12.8 10.8416 12.4424 11.2 12 11.2ZM18.4 8H5.6C5.1576 8 4.8 7.6416 4.8 7.2C4.8 6.7584 5.1576 6.4 5.6 6.4H18.4C18.8424 6.4 19.2 6.7584 19.2 7.2C19.2 7.6416 18.8424 8 18.4 8Z"
                              fill="#4DEC8C"
                            />
                          </svg>
                        </div>
                      </Link>

                      <div className="text-content">
                        <Dropdown.Item as={Link} to="/chat-ai-pricing">
                          <span className="lbl">ChatAi Pricing</span>
                          <span className="sub-title">
                            Pricing for Pro access to the EarningsCall AI Chat.
                          </span>
                        </Dropdown.Item>
                      </div>
                    </div>
                    <div className="item-container">
                      <Link to="/api-pricing">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M24 5.30233C24 3.89581 23.4419 2.54735 22.4473 1.55274C21.4527 0.55814 20.1042 0 18.6977 0H5.30233C3.89581 0 2.54735 0.55814 1.55274 1.55274C0.55814 2.54735 0 3.89581 0 5.30233V18.6977C0 20.1042 0.55814 21.4527 1.55274 22.4473C2.54735 23.4419 3.89581 24 5.30233 24H18.6977C20.1042 24 21.4527 23.4419 22.4473 22.4473C23.4419 21.4527 24 20.1042 24 18.6977V5.30233ZM12.5447 7.71684L9.86567 15.754C9.72056 16.1927 9.95721 16.6672 10.3959 16.8134C10.8346 16.9585 11.309 16.7219 11.4553 16.2832L14.1343 8.24595C14.2794 7.80726 14.0428 7.33284 13.6041 7.1866C13.1654 7.04149 12.691 7.27814 12.5447 7.71684ZM15.427 9.91256L17.5133 12L15.427 14.0874C15.0999 14.4134 15.0999 14.9447 15.427 15.2707C15.7529 15.5978 16.2843 15.5978 16.6102 15.2707L19.2893 12.5916C19.6164 12.2646 19.6164 11.7354 19.2893 11.4084L16.6102 8.7293C16.2843 8.40223 15.7529 8.40223 15.427 8.7293C15.0999 9.05525 15.0999 9.58661 15.427 9.91256ZM7.38977 8.7293L4.7107 11.4084C4.38363 11.7354 4.38363 12.2646 4.7107 12.5916L7.38977 15.2707C7.71572 15.5978 8.24707 15.5978 8.57302 15.2707C8.90009 14.9447 8.90009 14.4134 8.57302 14.0874L6.4867 12L8.57302 9.91256C8.90009 9.58661 8.90009 9.05525 8.57302 8.7293C8.24707 8.40223 7.71572 8.40223 7.38977 8.7293Z"
                              fill="#4DEC8C"
                            />
                          </svg>
                        </div>
                      </Link>

                      <div className="text-content">
                        <Dropdown.Item as={Link} to="/api-pricing">
                          <span className="lbl">API Pricing</span>
                          <span className="sub-title">
                            Pricing tiers for API Access to Earnings Calls.
                          </span>
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              <li className="nav-item">
                <Dropdown className="pricing-dropdown" align="center">
                  <Dropdown.Toggle>
                    Resources
                    <span className="toggle-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.219668 0.219668C0.512558 -0.0732225 0.987438 -0.0732225 1.28033 0.219668L5.75 4.6893L10.2197 0.219668C10.5126 -0.0732225 10.9874 -0.0732225 11.2803 0.219668C11.5732 0.512558 11.5732 0.987437 11.2803 1.2803L6.2803 6.2803C6.1397 6.421 5.9489 6.5 5.75 6.5C5.5511 6.5 5.3603 6.421 5.2197 6.2803L0.219668 1.2803C-0.0732225 0.987437 -0.0732225 0.512558 0.219668 0.219668Z"
                        />
                      </svg>
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="icon-polygon"></div>
                    <div className="item-container">
                      <Link to="/api-details">
                        <div className="icon">
                          <svg
                            id="Glyph"
                            viewBox="0 0 64 64"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#4dec8c"
                          >
                            <path d="m16.39 11.81847v-6.3l-10.55383 10.56458h6.2892a4.26743 4.26743 0 0 0 4.26463-4.26458z" />
                            <path d="m26.89 53.04305a1.06449 1.06449 0 0 1 -.01078-1.4c.32306-.36619 7.92613-9.1108 17.55383-9.1108.14 0 .28 0 .42.01078v-34.28917a4.25594 4.25594 0 0 0 -4.25384-4.25386h-22.05536v7.81847a6.42758 6.42758 0 0 1 -6.41848 6.41842h-7.81848v36.28154a4.26291 4.26291 0 0 0 4.25386 4.25386h25.16769a31.67664 31.67664 0 0 1 -6.83844-5.72924zm11.92155-17.01537h-12.04a1.077 1.077 0 0 1 0-2.15384h12.04a1.077 1.077 0 0 1 0 2.15384zm-12.04-16.3908h12.04a1.077 1.077 0 0 1 0 2.15384h-12.03999a1.077 1.077 0 0 1 0-2.15384zm-16.42307 7.11851h28.46307a1.07711 1.07711 0 0 1 -.00007 2.15384h-28.463a1.07706 1.07706 0 0 1 0-2.15384zm12.05077 22.57226h-12.05077a1.077 1.077 0 0 1 0-2.15384h12.05077a1.077 1.077 0 0 1 0 2.15384zm0-6.64459h-12.05077a1.077 1.077 0 0 1 0-2.15385h12.05077a1.077 1.077 0 0 1 0 2.15385zm0-6.65538h-12.05077a1.077 1.077 0 0 1 0-2.15384h12.05077a1.077 1.077 0 0 1 0 2.15384zm3.29539 5.57845a1.08006 1.08006 0 0 1 1.07692-1.07692h7.93692a1.07693 1.07693 0 0 1 0 2.15385h-7.93692a1.08006 1.08006 0 0 1 -1.07692-1.07693z" />
                            <path d="m45.94078 44.77229c-7.04015-1.06131-14.83319 5.38211-16.7676 7.571a28.97483 28.97483 0 0 0 9.51993 6.5152 15.89444 15.89444 0 0 0 5.73995 1.14151c7.11844 0 13.28926-5.64306 15.26005-7.6569-1.83079-1.87391-7.28002-6.87078-13.75233-7.57081zm-1.50772 10.92a3.34945 3.34945 0 0 1 .0001-6.6985 3.34945 3.34945 0 0 1 -.0001 6.69852z" />
                            <path d="m44.43306 51.14766a1.19554 1.19554 0 0 0 .00005 2.3908 1.19554 1.19554 0 0 0 -.00005-2.3908z" />
                          </svg>
                        </div>
                      </Link>
                      <div className="text-content">
                        <Dropdown.Item as={Link} to="/api-details">
                          <span className="lbl">EarningsCall API</span>
                          <span className="sub-title">
                            Empower Your Analytics with Comprehensive Earnings
                            Data from 5,000+ Companies
                          </span>
                        </Dropdown.Item>
                      </div>
                    </div>
                    <div className="item-container">
                      <Link to="/api-guide">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="24"
                            viewBox="0 0 20 24"
                            fill="none"
                          >
                            <path
                              d="M4.16667 0C1.87275 0 0 1.87275 0 4.16667V19.1667C0 21.4606 1.87275 23.3333 4.16667 23.3333H19.1667C19.6269 23.3333 20 22.9602 20 22.5V4.16667C20 3.70645 19.6269 3.33338 19.1667 3.33333H16.6667V0.833333C16.6666 0.373117 16.2936 5e-05 15.8333 0H4.16667ZM16.6667 5H18.3333V21.6667H4.16667C2.76725 21.6667 1.66667 20.5661 1.66667 19.1667C1.66667 17.7673 2.76725 16.6667 4.16667 16.6667H15.8333C16.2936 16.6666 16.6666 16.2936 16.6667 15.8333V5Z"
                              fill="#4DEC8C"
                            />
                            <path
                              d="M15.8101 18.3332H4.16674C3.0398 18.3173 3.0398 20.0158 4.16674 19.9999H15.8101C16.2799 20.0066 16.6621 19.6233 16.6549 19.1586C16.6474 18.6939 16.2697 18.3269 15.8101 18.3332Z"
                              fill="#4DEC8C"
                            />
                          </svg>
                        </div>
                      </Link>
                      <div className="text-content">
                        <Dropdown.Item as={Link} to="/api-guide">
                          <span className="lbl">API Documentation</span>
                          <span className="sub-title">
                            Complete Documentation of APIs with Detailed Request
                            and Response Structures
                          </span>
                        </Dropdown.Item>
                      </div>
                    </div>
                    <div className="item-container">
                      <Link to="/blog">
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M18.5455 24H5.45455C5.16522 24 4.88774 23.8851 4.68316 23.6805C4.47857 23.4759 4.36364 23.1984 4.36364 22.9091C4.36364 22.6198 4.47857 22.3423 4.68316 22.1377C4.88774 21.9331 5.16522 21.8182 5.45455 21.8182H18.5455C18.8348 21.8182 19.1123 21.9331 19.3168 22.1377C19.5214 22.3423 19.6364 22.6198 19.6364 22.9091C19.6364 23.1984 19.5214 23.4759 19.3168 23.6805C19.1123 23.8851 18.8348 24 18.5455 24ZM24 5.45455V14.1818C24 14.8981 23.8589 15.6074 23.5848 16.2692C23.3107 16.931 22.9089 17.5323 22.4024 18.0388C21.8959 18.5453 21.2946 18.947 20.6328 19.2212C19.971 19.4953 19.2618 19.6364 18.5455 19.6364H5.45455C4.73824 19.6364 4.02896 19.4953 3.36718 19.2212C2.70541 18.947 2.1041 18.5453 1.5976 18.0388C0.574674 17.0158 0 15.6285 0 14.1818V5.45455C0 4.00791 0.574674 2.62053 1.5976 1.5976C2.62053 0.574674 4.00791 0 5.45455 0H18.5455C19.2618 0 19.971 0.141086 20.6328 0.415203C21.2946 0.689319 21.8959 1.0911 22.4024 1.5976C22.9089 2.1041 23.3107 2.70541 23.5848 3.36718C23.8589 4.02896 24 4.73824 24 5.45455ZM4.36364 7.63636C4.36364 7.92569 4.47857 8.20317 4.68316 8.40775C4.88774 8.61234 5.16522 8.72727 5.45455 8.72727H12C12.2893 8.72727 12.5668 8.61234 12.7714 8.40775C12.976 8.20317 13.0909 7.92569 13.0909 7.63636C13.0909 7.34704 12.976 7.06956 12.7714 6.86497C12.5668 6.66039 12.2893 6.54545 12 6.54545H5.45455C5.16522 6.54545 4.88774 6.66039 4.68316 6.86497C4.47857 7.06956 4.36364 7.34704 4.36364 7.63636ZM19.6364 12C19.6364 11.7107 19.5214 11.4332 19.3168 11.2286C19.1123 11.024 18.8348 10.9091 18.5455 10.9091H5.45455C5.16522 10.9091 4.88774 11.024 4.68316 11.2286C4.47857 11.4332 4.36364 11.7107 4.36364 12C4.36364 12.2893 4.47857 12.5668 4.68316 12.7714C4.88774 12.976 5.16522 13.0909 5.45455 13.0909H18.5455C18.8348 13.0909 19.1123 12.976 19.3168 12.7714C19.5214 12.5668 19.6364 12.2893 19.6364 12Z"
                              fill="#4DEC8C"
                            />
                          </svg>
                        </div>
                      </Link>
                      <div className="text-content">
                        <Dropdown.Item as={Link} to="/blog">
                          <span className="lbl">Blog</span>
                          <span className="sub-title">
                            Read our latest insights and updates on Earnings
                            Calls
                          </span>
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              <li className="nav-item d-md-none">
                <Nav.Link
                  as={Link}
                  to="/about"
                  className={isActive(pathname, "/about")}
                >
                  About Us
                </Nav.Link>
              </li>
              <li className="nav-item d-md-none">
                <Nav.Link
                  as={Link}
                  to="/top-employers"
                  className={isActive(pathname, "/top-employers")}
                >
                  Top Employers
                </Nav.Link>
              </li>

              {isLoggedIn ? (
                <>
                  {isAdminUser && false && (
                    <>
                      <Navbar.Text
                        style={{ color: "rgba(255, 195, 158, 0.5)" }}
                        className="me-4"
                      >
                        ADMIN
                      </Navbar.Text>
                    </>
                  )}
                  {email && (
                    <NavDropdown
                      title={
                        <>
                          <span className="profile-cover">
                            <img src={imageUrl || userAvatar} alt="profile" />
                          </span>
                          <span className="profile-name">
                            {userDisplayName}
                          </span>
                          <span className="toggle-icon ms-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="7"
                              viewBox="0 0 12 7"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.219668 0.219668C0.512558 -0.0732225 0.987438 -0.0732225 1.28033 0.219668L5.75 4.6893L10.2197 0.219668C10.5126 -0.0732225 10.9874 -0.0732225 11.2803 0.219668C11.5732 0.512558 11.5732 0.987437 11.2803 1.2803L6.2803 6.2803C6.1397 6.421 5.9489 6.5 5.75 6.5C5.5511 6.5 5.3603 6.421 5.2197 6.2803L0.219668 1.2803C-0.0732225 0.987437 -0.0732225 0.512558 0.219668 0.219668Z"
                              />
                            </svg>
                          </span>
                        </>
                      }
                      id="basic-nav-dropdown"
                    >
                      <NavDropdown.Item
                        as={Link}
                        to="/account"
                        className={isActive(pathname, "/account")}
                      >
                        Account
                      </NavDropdown.Item>
                      {enableSubscriptionPage && (
                        <>
                          <NavDropdown.Item
                            as={Link}
                            to="/subscriptions"
                            className={isActive(pathname, "/subscriptions")}
                          >
                            Subscriptions
                          </NavDropdown.Item>
                        </>
                      )}
                      {enableApiKeyPage && (
                        <>
                          <NavDropdown.Item
                            as={Link}
                            to="/api-key"
                            className={isActive(pathname, "/api-key")}
                          >
                            API Key
                          </NavDropdown.Item>
                        </>
                      )}
                      {enableStripeCustomerAdmin && (
                        <>
                          <NavDropdown.Item
                            as={Link}
                            to="/admin"
                            className={isActive(pathname, "/admin")}
                          >
                            Admin
                          </NavDropdown.Item>
                          <NavDropdown.Item
                            as={Link}
                            to="/developer"
                            className={isActive(pathname, "/developer")}
                          >
                            Developer
                          </NavDropdown.Item>
                        </>
                      )}
                      <NavDropdown.Item as="button" onClick={onLogout}>
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}
                </>
              ) : (
                <>
                  <li className="nav-item d-block d-md-block">
                    <Nav.Link
                      as={Link}
                      to="/login"
                      className={`${isActive(pathname, "/login")}`}
                    >
                      Login
                    </Nav.Link>
                  </li>
                </>
              )}
            </ul>
            <ul className="navbar-nav align-items-md-center ms-auto right-nav">
              <li className="nav-item nav-item-searchIcon d-md-block d-none ">
                <button
                  className="btn btn-primary"
                  onClick={() => setSearchActive(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="#292929"
                  >
                    <path
                      d="M19.8296 19.0071L15.2853 14.4628C16.68 12.8724 17.4496 10.8599 17.4496 8.7248C17.4496 6.39421 16.5419 4.20336 14.8941 2.55553C13.2463 0.907698 11.0554 0 8.7248 0C6.39421 0 4.20336 0.907698 2.55553 2.55553C0.907698 4.20336 0 6.39421 0 8.7248C0 11.0554 0.907698 13.2463 2.55553 14.8941C4.20336 16.5419 6.39421 17.4496 8.7248 17.4496C10.8599 17.4496 12.8724 16.68 14.4628 15.2853L19.0071 19.8296C19.1207 19.9432 19.2695 20 19.4184 20C19.5672 20 19.716 19.9432 19.8296 19.8296C20.0568 19.6024 20.0568 19.2343 19.8296 19.0071ZM3.37802 14.0716C1.95002 12.6433 1.16331 10.7444 1.16331 8.7248C1.16331 6.7052 1.95002 4.80631 3.37802 3.37802C4.80631 1.95002 6.7052 1.16331 8.7248 1.16331C10.7444 1.16331 12.6433 1.95002 14.0716 3.37802C15.4996 4.80631 16.2863 6.7052 16.2863 8.7248C16.2863 10.7444 15.4996 12.6433 14.0716 14.0716C12.6433 15.4996 10.7444 16.2863 8.7248 16.2863C6.7052 16.2863 4.80631 15.4996 3.37802 14.0716Z"
                      fill="#292929"
                    />
                  </svg>
                </button>
              </li>
              <li className="nav-item d-md-block d-none">
                <button onClick={handleShow} className="btn btn-download">
                  Download App
                </button>
              </li>
            </ul>

            <div className="copy-right-container ">
              <p className="copy-right-text">Download Apps</p>
              <StoreBadge
                name="EarningsCall"
                googlePlayUrl={GOOGLE_PLAY_STORE_URL}
                appStoreUrl={APPLE_APP_STORE_URL}
                className="container-download"
              />

              <div className="design-by d-none">
                <a href="https://codixel.tech/" target="_blank" rel="dofollow">
                  <span className="by">Designed By</span>
                  <img src={codixel} alt="Codixel" />
                </a>
              </div>
              <p className="copy-right-text text-center d-none">
                &copy;EarningsCall, LLC {new Date().getFullYear()}
              </p>
            </div>
            {isLoggedIn && session && false && (
              <Navbar.Text className="me-2">
                Session Token Hours Left: {hoursRemaining}
              </Navbar.Text>
            )}
          </Navbar.Collapse>

          <div className="search-bar">
            <span className="nav-bar-company-search d-flex my-1">
              <SearchBar
                id="navBarSearchBar"
                renderForm={false}
                renderSearchButton={false}
                placeholder="Find company"
              />

              <span
                className="close-search"
                onClick={() => setSearchActive(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#4dec8c"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </span>
          </div>
        </Container>
      </Navbar>
      <BreadCrumbTrail {...props} />
      <DownloadModal show={show} handleClose={handleClose} />
    </>
  );
};

export default MainNavbar;
